export default __webpack_public_path__ + "static/media/char_head_006.4fc7948f.png";